"use client";
import { jsx as t } from "react/jsx-runtime";
import { withCmsDataHandling as a } from "../../../handlers/withCmsDataHandling/withCmsDataHandling.js";
import s from "../../layout/Container/Container.js";
import { Html as n, sharedHandler as p } from "@ingeniorforeningen/figurine-core";
import { forwardRef as l } from "react";
import { richtextDeliveryApiParser as d } from "./Richtext.helpers.js";
const r = l((e, i) => {
  const { html: m, ...o } = e;
  return /* @__PURE__ */ t(s, { size: "sm", ...o, children: /* @__PURE__ */ t(n, { ref: i, html: m }) });
});
r.displayName = "Richtext";
const c = a({
  Component: p(r),
  deliveryApiParser: d
});
c.displayName = r.displayName;
export {
  r as _Richtext,
  c as default
};
